<template>
  <div class="wrapper">
    <nav id="topbar" class="no-selection">
      <component :is="mode"></component>
    </nav>
    <div v-if="hasDrawingMode && mode === 'drawing'" id="sidebar">
      <Sidebar />
    </div>
  </div>
</template>
<script lang="ts">
import { mapState } from 'vuex';
import { MODE } from '@/constants';
import LayoutChooser from './Layout/Layout.vue';
import Main from './Main/Main.vue';
import Sidebar from './Sidebar.vue';

export default {
  name: 'TopBar',
  components: {
    [MODE.LAYOUTCHOOSER]: LayoutChooser,
    [MODE.INITIAL]: Main,
    [MODE.LABELS]: Main,
    [MODE.CATEGORIES]: Main,
    [MODE.POS]: Main,
    [MODE.BLOCKSEATS]: Main,
    [MODE.DRAWING]: Main,
    [MODE.GROUP]: Main,
    Sidebar,
  },
  computed: {
    ...mapState('settings', ['mode']),
    hasDrawingMode() {
      return this.$app.props.options.modes.map((s) => s.toLowerCase()).includes('drawing');
    },
  },
};
</script>

<style lang="scss">
#topbar {
  position: relative;
  z-index: 65 !important;
}
#logo {
  position: absolute;
  left: 60px;
  top: 15px;
  z-index: 1;
}
#sidebar {
  float: left;
  .full-control {
    z-index: 65 !important;
    left: -100%;
    transition: cubic-bezier(0, 1, 1, 1) 0.2s;
    -webkit-transition: cubic-bezier(0, 1, 1, 1) 0.2s;
    -moz-transition: cubic-bezier(0, 1, 1, 1) 0.2s;
    > .md-icon {
      display: none;
    }
  }
  &.show {
    .full-control {
      left: 0;
      > .md-icon {
        display: block;
      }
    }
  }
}
</style>
